import ThumbnailWorkoutList from "../../../common/Thumbnails/ThumbnailWorkoutList";
import PaddedContentArea from "../../../common/PaddedContentArea";

function Upnext({
    initialSlide,
    screenSize,
    workouts = [],
    program,
    level,
    viewedWorkout,
}) {

    return (
        <div id="program-videos-panel">
            <PaddedContentArea>
                <h5>FULL PROGRAM</h5>
                <ThumbnailWorkoutList viewedWorkout={viewedWorkout} content={workouts} program={program} level={level} withDate={false} midView={2} smallView={1.6} orientation='y' screenSize={screenSize} />
            </PaddedContentArea>
        </div>
    );
}

export default Upnext;